export class GdsgStorageBreakdownEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageClass",
            "baseName": "storageClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalStorageBytes",
            "baseName": "totalStorageBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgStorageBreakdownEntry.attributeTypeMap;
    }
    constructor() {
    }
}
